import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { device_platform } from '../constants/device_platform';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { DeviceService } from '../services/device.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CookieService } from 'ngx-cookie-service';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '../services/dialog.service';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { SnackbarService } from './snackbar.service';
import { isPlatformServer, Location } from '@angular/common';
import { DeptService } from '../models/all-services.model';
import { UserProfile } from '../models/user-profile.model';
import { ErrorDialogComponent } from '../components/utility/error-dialog/error-dialog.component';
import { CachingService } from './caching.service';

declare var Scheme: any;
declare const isLoadService: (data: {
  serviceId: string;
  allServices: DeptService[];
  userProfile: UserProfile;
}) => { loadService: boolean; errorMessage: string; callback?: () => void };

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  bookmarkSchemes: any = [];
  bookmark = new Subject<string>();
  bookmarkData$ = this.bookmark.asObservable();
  rawBookMarkData: any;
  public _uInfo: any = null;
  public themeCheck = new BehaviorSubject<'dark' | 'light' | null>(null);
  httpOptions = {
    headers: new HttpHeaders(),
    params: new HttpParams(),
    observe: null,
    responseType: null
  };
  private deviceInfo;
  constructor(
    private deviceDetectorService: DeviceDetectorService,
    private cookieService: CookieService,
    private deviceService: DeviceService,
    private router: Router,
    public dialog: MatDialog,
    public dialogService: DialogService,
    public analytics: AngularFireAnalytics,
    public snackbarService: SnackbarService,
    private location: Location,
    private cachingService: CachingService,

    @Inject(PLATFORM_ID) private platformId: string


  ) {
    deviceService.detectDevice();
    this.deviceInfo =  this.deviceDetectorService.getDeviceInfo();
  }

  getDeptUrl(url: string) {
    let protocol = 'https://';
    if (url.includes('http://')) {
      protocol = 'http://';
    }
    const urlWithoutProtocol = url.split(protocol)[1];
    return urlWithoutProtocol.slice(urlWithoutProtocol.indexOf('/') + 1);
  }


  public isWebView(): boolean {
    if (isPlatformServer(this.platformId)) {
      return false;
    }
    const USER_AGENT = navigator.userAgent;
    const IS_COOKIE_PRESENT = this.deviceDetectorService.isMobile() ? (this.cookieService.get('Web-View') === "true" ? true : false) : false;
    if (this.deviceDetectorService.isMobile() && (IS_COOKIE_PRESENT || ((this.deviceService && this.deviceService.deviceInfo && this.deviceService.deviceInfo.os.toLowerCase() === device_platform.android) && (USER_AGENT.includes('Version/') || USER_AGENT.includes('wv'))) || ((this.deviceService && this.deviceService.deviceInfo && this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios) && (this.deviceInfo.browser === 'Unknown')))) {
      return true;
    }
    else {
      return false;
    }
  }

  public schemeTagSearch(queryParams: any) {
    if (this.isWebView()) {
      if (this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() ===
        device_platform.android
      ) {
        Scheme && Scheme.schemeSearch(`${JSON.stringify(queryParams)}`);
      } else if (
        this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios
      ) {
        document.location.href = "ios::schemeSearch::" + `${JSON.stringify(queryParams)}`;
      }
    } else {
      // this.location.back();
      if (queryParams?.data) {
        this.router.navigate(['/scheme/search'], { queryParams: { tag: queryParams?.data } });
      } else {
        this.location.back();
      }
    }
  }

  public ministrySearch(queryParams: any) {
    if (this.isWebView()) {
      if (this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() ===
        device_platform.android
      ) {
        console.log(Scheme)
        Scheme && Scheme.schemeSearch(`${JSON.stringify(queryParams)}`);
      } else if (
        this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios
      ) {
        document.location.href = "ios::schemeSearch::" + `${JSON.stringify(queryParams)}`;
      }
    } else {
      const eventFilter = queryParams.filter;
      const eventMessage = queryParams.data;
      switch (eventFilter) {
        case 'ministry':
          const ministryQueryParams = { ministry: eventMessage };
          this.router.navigate(['/scheme/search'], { queryParams: ministryQueryParams });
          break;
        case 'beneficiaryState':
          const stateQueryParams = { state: eventMessage };
          this.router.navigate(['/scheme/search'], { queryParams: stateQueryParams });
          break;
        default:
          this.router.navigate(['/scheme/search']);
          break;
      }
    }
  }



  // public applyNow() {
  //   console.warn('in apply', this.isWebView());
  //   if (this.isWebView()) {
  //     if ( this.deviceService && this.deviceService.deviceInfo && 
  //       this.deviceService.deviceInfo.os.toLowerCase() ===
  //       device_platform.android
  //     ) {
  //       console.warn('scheme',Scheme)
  //       Scheme && Scheme.schemeApply(JSON.stringify(message));
  //     } else if (
  //       this.deviceService && this.deviceService.deviceInfo && 
  //       this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios
  //     ) {
  //       document.location.href = `ios::applyScheme::${JSON.stringify(message)}`;
  //     }
  //   } else {
  //     window.parent.postMessage('successModal', '*');
  //   }
  // }

  // public checkEligibility(message: { checkEligibility: string; mesage: string; }) {
  //   console.warn('not', message);
  //   if (this.isWebView()) {
  //     if ( this.deviceService && this.deviceService.deviceInfo && 
  //       this.deviceService.deviceInfo.os.toLowerCase() ===
  //       device_platform.android
  //     ) {
  //       console.log(Scheme)
  //       Scheme && Scheme.schemeCheckEligibility(JSON.stringify(message));
  //     } else if (
  //       this.deviceService && this.deviceService.deviceInfo && 
  //       this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios
  //     ) {
  //       document.location.href = `ios::schemeCheckEligibility::${JSON.stringify(message)}`;
  //     }
  //   } else {
  //     window.parent.postMessage('successModal', '*');
  //   }
  // }

  public isSupportiveVersion(): any {
    if (this.isWebView()) {
      const profileData = this.cookieService.get("Umang-X-App-Data")
        ? JSON.parse(this.cookieService.get("Umang-X-App-Data"))
        : {};
      const APP_VERSION = profileData["ver"] || 0; // check version of APP
      if (APP_VERSION > 0) {
        if (
          this.deviceService.deviceInfo.os.toLowerCase() ===
          device_platform.android
        ) {
          if (APP_VERSION >= environment.appVersion.android) {
            return true;
          } else {
            return false;
          }
        } else if (this.getiOSOrMac()) {
          if (APP_VERSION >= environment.appVersion.ios) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public openLink(link: { url: string }) {
    if (this.isWebView()) {
      if (this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() ===
        device_platform.android
      ) {
        Scheme && Scheme.openBrowserScheme(`${JSON.stringify(link)}`);
      } else if (
        this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios
      ) {
        document.location.href = "ios::openBrowser::" + `${JSON.stringify(link)}`;
      }
    } else {
      window.open(link.url);
    }
  }

  public getiOSOrMac() {
    return (
      this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios ||
      this.deviceService.deviceInfo.os.toLowerCase() === device_platform.mac
    );
  }

  // openDownloadableLink(url: string): void {
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.target = '_blank';
  //   link.download = '';
  //   link.click();
  // }

  public filterSearch(queryParams: any) {
    if (this.isWebView()) {
      if (this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() ===
        device_platform.android
      ) {
        Scheme && Scheme.findSchemeForYou(`${JSON.stringify(queryParams)}`);
      } else if (
        this.deviceService && this.deviceService.deviceInfo &&
        this.deviceService.deviceInfo.os.toLowerCase() === device_platform.ios
      ) {
        document.location.href = "ios::findSchemeForYou::" + `${JSON.stringify(queryParams)}`;
      }
    } else {
      window.parent.postMessage(queryParams, '*');
    }
  }

  checkSrvAccess(
    serviceId: string,
    serviceObj: DeptService,
    services: DeptService[]
  ) {
    const { loadService, errorMessage, callback } = isLoadService({
      serviceId,
      allServices: services,
      userProfile: this.cachingService.userProfile,
    });

    if (!loadService) {
      if (callback) {
        callback();
      } else {
        this.dialogService.openDialog(ErrorDialogComponent, errorMessage);
      }
    }

    return loadService;
  }

  get getBookmarkData() {
    return this.bookmarkSchemes;
  }

  markBookmark(payload: any, data: any) {
    const index = this.bookmarkSchemes?.findIndex(
      (item: any) => item.slug === data?.slug
    );
    if (index !== -1) {
      this.bookmarkSchemes.splice(index, 1);
      this.snackbarService.addedBookmark(false, data.schemeName);
    } else {
      this.bookmarkSchemes.push(data);
      this.snackbarService.addedBookmark(true, data.schemeName);
    }
    this.bookmark.next(this.bookmarkSchemes);
    //this.mySchemeService.createBookmark(payload).subscribe((res) => {});
  }

  getLocalStorageItem(keyName: string) {
    return localStorage.getItem(keyName);
  }


  setTheme(themeType: boolean) {
    localStorage.setItem('theme', themeType ? 'dark' : 'light');
    this.themeCheck.next(themeType ? 'dark' : 'light');
    if (themeType) {
      document.getElementsByTagName('HTML')[0].setAttribute('class', 'dark');
    } else {
      document.getElementsByTagName('HTML')[0].removeAttribute('class');
    }
  }

  arrayToCSV(arr: any[]) {
    const csvRows = [];
    const headers = Object.keys(arr[0]);
    csvRows.push(headers.join(','));
    for (const row of arr) {
      const values = headers.map(header => {
        const escaped = ('' + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    }
    return csvRows.join('\n');
  }


  downloadCSV(data: any, filename = 'stateWiseData.csv') {
    const csvString = this.arrayToCSV(data);
    const blob = new Blob([csvString], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a: any = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

}